export function spaceDelimitedList(
  list: (string | null | undefined)[],
): string | undefined {
  return list.filter(Boolean).join(" ") || undefined;
}
